import SpSettingContainer from "./SpSetting.container";

export default SpSettingContainer;
